import * as api from '../api/bppPenalty';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_BPP_PENALTY_CONFIGURATIONS = createRequestTypes(
  `${prefix}/FETCH_BPP_PENALTY_CONFIGURATIONS`,
);

export const fetchBPPPenaltyConfigurations = makeApiActionCreatorV3(
  api.fetchBPPPenaltyConfigurations,
  FETCH_BPP_PENALTY_CONFIGURATIONS[START],
  FETCH_BPP_PENALTY_CONFIGURATIONS[SUCCESS],
  FETCH_BPP_PENALTY_CONFIGURATIONS[ERROR],
);

export const UPDATE_BPP_PENALTY_CONFIGURATION = createRequestTypes(
  `${prefix}/UPDATE_BPP_PENALTY_CONFIGURATION`,
);

export const updateBPPPenaltyConfiguration = makeApiActionCreatorV3(
  api.updateBPPPenaltyConfiguration,
  UPDATE_BPP_PENALTY_CONFIGURATION[START],
  UPDATE_BPP_PENALTY_CONFIGURATION[SUCCESS],
  UPDATE_BPP_PENALTY_CONFIGURATION[ERROR],
);

export const FETCH_BPP_PENALTY_RUNS = createRequestTypes(
  `${prefix}/FETCH_BPP_PENALTY_RUNS`,
);

export const fetchBPPPenaltyRuns = makeApiActionCreatorV3(
  api.fetchBPPPenaltyRuns,
  FETCH_BPP_PENALTY_RUNS[START],
  FETCH_BPP_PENALTY_RUNS[SUCCESS],
  FETCH_BPP_PENALTY_RUNS[ERROR],
);

export const FETCH_BPP_PENALTY_RUN = createRequestTypes(
  `${prefix}/FETCH_BPP_PENALTY_RUN`,
);

export const fetchBPPPenaltyRun = makeApiActionCreatorV3(
  api.fetchBPPPenaltyRun,
  FETCH_BPP_PENALTY_RUN[START],
  FETCH_BPP_PENALTY_RUN[SUCCESS],
  FETCH_BPP_PENALTY_RUN[ERROR],
);

export const ADD_BPP_PENALTY_RUN = createRequestTypes(
  `${prefix}/ADD_BPP_PENALTY_RUN`,
);

export const addBPPPenaltyRun = makeApiActionCreatorV3(
  api.addBPPPenaltyRun,
  ADD_BPP_PENALTY_RUN[START],
  ADD_BPP_PENALTY_RUN[SUCCESS],
  ADD_BPP_PENALTY_RUN[ERROR],
);

export const FETCH_BPP_PENALTY_RUN_TYPES = createRequestTypes(
  `${prefix}/FETCH_BPP_PENALTY_RUN_TYPES`,
);

export const fetchBPPPenaltyRunTypes = makeApiActionCreatorV3(
  api.fetchBPPPenaltyRunTypes,
  FETCH_BPP_PENALTY_RUN_TYPES[START],
  FETCH_BPP_PENALTY_RUN_TYPES[SUCCESS],
  FETCH_BPP_PENALTY_RUN_TYPES[ERROR],
);

export const CAPTURE_BPP_PENALTY_PROPERTY_DATA = createRequestTypes(
  `${prefix}/CAPTURE_BPP_PENALTY_PROPERTY_DATA`,
);

export const captureBPPPenaltyPropertyData = makeApiActionCreatorV3(
  api.captureBPPPenaltyPropertyData,
  CAPTURE_BPP_PENALTY_PROPERTY_DATA[START],
  CAPTURE_BPP_PENALTY_PROPERTY_DATA[SUCCESS],
  CAPTURE_BPP_PENALTY_PROPERTY_DATA[ERROR],
);

export const FETCH_BPP_PENALTY_PROPERTY_DATA = createRequestTypes(
  `${prefix}/FETCH_BPP_PENALTY_PROPERTY_DATA`,
);

export const fetchBPPPenaltyPropertyData = makeApiActionCreatorV3(
  api.fetchBPPPenaltyPropertyData,
  FETCH_BPP_PENALTY_PROPERTY_DATA[START],
  FETCH_BPP_PENALTY_PROPERTY_DATA[SUCCESS],
  FETCH_BPP_PENALTY_PROPERTY_DATA[ERROR],
);

export const PROCESS_BPP_PENALTY_RUN = createRequestTypes(
  `${prefix}/PROCESS_BPP_PENALTY_RUN`,
);

export const processBPPPenaltyRun = makeApiActionCreatorV3(
  api.processBPPPenaltyRun,
  PROCESS_BPP_PENALTY_RUN[START],
  PROCESS_BPP_PENALTY_RUN[SUCCESS],
  PROCESS_BPP_PENALTY_RUN[ERROR],
);

export const CREATE_BPP_PENALTY_RUN_EXPORT = createRequestTypes(
  `${prefix}/CREATE_BPP_PENALTY_RUN_EXPORT`,
);

export const createBPPPenaltyRunExport = makeApiActionCreatorV3(
  api.createBPPPenaltyRunExport,
  CREATE_BPP_PENALTY_RUN_EXPORT[START],
  CREATE_BPP_PENALTY_RUN_EXPORT[SUCCESS],
  CREATE_BPP_PENALTY_RUN_EXPORT[ERROR],
);

export const DOWNLOAD_BPP_PENALTY_RUN_EXPORT = createRequestTypes(
  `${prefix}/DOWNLOAD_BPP_PENALTY_RUN_EXPORT`,
);

export const downloadBPPPenaltyRunExport = makeApiActionCreatorV3(
  api.downloadBPPPenaltyRunExport,
  DOWNLOAD_BPP_PENALTY_RUN_EXPORT[START],
  DOWNLOAD_BPP_PENALTY_RUN_EXPORT[SUCCESS],
  DOWNLOAD_BPP_PENALTY_RUN_EXPORT[ERROR],
);

export const DOWNLOAD_BPP_PENALTY_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_BPP_PENALTY_FILE`,
);

export const downloadBPPPenaltyFile = makeApiActionCreatorV3(
  api.downloadBPPPenaltyFile,
  DOWNLOAD_BPP_PENALTY_FILE[START],
  DOWNLOAD_BPP_PENALTY_FILE[SUCCESS],
  DOWNLOAD_BPP_PENALTY_FILE[ERROR],
);

export const UPLOAD_BPP_PENALTY_FILE = createRequestTypes(
  `${prefix}/UPLOAD_BPP_PENALTY_FILE`,
);

export const uploadBPPPenaltyFile = makeApiActionCreatorV3(
  api.uploadBPPPenaltyFile,
  UPLOAD_BPP_PENALTY_FILE[START],
  UPLOAD_BPP_PENALTY_FILE[SUCCESS],
  UPLOAD_BPP_PENALTY_FILE[ERROR],
);

export const DELETE_BPP_PENALTY_FILE = createRequestTypes(
  `${prefix}/DELETE_BPP_PENALTY_FILE`,
);

export const deleteBPPPenaltyFile = makeApiActionCreatorV3(
  api.deleteBPPPenaltyFile,
  DELETE_BPP_PENALTY_FILE[START],
  DELETE_BPP_PENALTY_FILE[SUCCESS],
  DELETE_BPP_PENALTY_FILE[ERROR],
);

export const EDIT_BPP_PENALTY_FILE = createRequestTypes(
  `${prefix}/EDIT_BPP_PENALTY_FILE`,
);

export const editBPPPenaltyFile = makeApiActionCreatorV3(
  api.editBPPPenaltyFile,
  EDIT_BPP_PENALTY_FILE[START],
  EDIT_BPP_PENALTY_FILE[SUCCESS],
  EDIT_BPP_PENALTY_FILE[ERROR],
);
